import { API_ROUTES } from '@app/common';
import type { Brand, CreateBrandInput } from '@app/common';
import { apiFetch } from './index';

export type { Brand, CreateBrandInput } from '@app/common';

export const listBrands = (): Promise<Brand[]> => apiFetch<Brand[]>(API_ROUTES.BRANDS);

export const createBrand = (input: CreateBrandInput): Promise<Brand> =>
  apiFetch<Brand>(API_ROUTES.BRANDS, {
    method: 'POST',
    body: JSON.stringify(input),
  });
